// @flow

export const DATE = 'MMM D, YYYY';
export const DATE_TIME = 'MMM D, YYYY h:mm a';
